import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { IStore } from '../../store/types'
import { SearchWorkspace } from '../../components/SearchWorkspace'
import { useAppDispatch } from '../../store'
import { searchChats } from '../../store/searchChatsTechSupport/actions'
import { STATUSES_CHAT_TECH } from '../../utils/consts'
import { ROUTES } from '../../utils/routes'

export const SearchChatTechSupport: React.FC = () => {
  const { searchChatsTechSupport } = useSelector((store: IStore) => store)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  React.useEffect(() => {
    if (!searchChatsTechSupport.data) {
      dispatch(searchChats({}))
    }
  }, [searchChatsTechSupport.data])

  const handleChangePage = (page: number) => {
    if (!searchChatsTechSupport.data) return null
    if (searchChatsTechSupport.data.pages >= page) {
      dispatch(searchChats({ ...searchChatsTechSupport.searchFields, page }))
    }
  }

  const handleGetDialog = (dialogId: number) => {
    navigate(ROUTES.changeSearch(dialogId))
  }

  return (
    <SearchWorkspace
      types={STATUSES_CHAT_TECH}
      data={searchChatsTechSupport.data}
      changePage={handleChangePage}
      getDialog={handleGetDialog}
    />
  )
}
